import _Api from '@/api/_Api';

import { ApiPersonInterface } from '@/interfaices/Persons';

export default class FormApi extends _Api {
   static async check_person(person: ApiPersonInterface, token: string) {
      const response = await this.http().post('v1/persons/embed.json', person, { headers: { Authorization: 'Bearer ' + token } });
      return response.data;
   }
}
